import React, { FC } from "react";
import { useAddProxyServiceContext } from "./AddProxyServiceProvider";
import { AddProxyServiceWizardStep } from "./AddProxyServiceWizardStep";
import { ProxyServiceLayers } from "./ProxyServiceLayers";

export const AddProxyServiceLayers: FC = () => {
  const { layers } = useAddProxyServiceContext();

  return (
    <AddProxyServiceWizardStep nextStepDisabled={layers.length === 0}>
      <ProxyServiceLayers />
    </AddProxyServiceWizardStep>
  );
};
